import styled, { keyframes } from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Transaction } from '../../../services/types';
import {
  OnePageScreen,
  GreenCard,
  CheckIcon,
  LION_GREEN,
} from '../components/OnePageLayout';

const popIn = keyframes`
  0%   { transform: scale(0.5); opacity: 0; }
  70%  { transform: scale(1.15); }
  100% { transform: scale(1); opacity: 1; }
`;

const CheckCircle = styled.div`
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: ${LION_GREEN};
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  margin: 0 auto 16px;
  animation: ${popIn} 0.4s ease;
`;

const SuccessTitle = styled.div`
  font-size: 18px;
  font-weight: 700;
  color: #333;
  text-align: center;
  margin-bottom: 8px;
`;

const SuccessDesc = styled.div`
  font-size: 13px;
  color: ${LION_GREEN};
  text-align: center;
  line-height: 1.5;
`;

interface Props {
  transaction: Transaction;
  uuid: string;
  onRedirect: () => void;
}

const OnePageSuccessPage = ({ transaction, uuid, onRedirect }: Props) => {
  const { t } = useTranslation();
  return (
    <OnePageScreen
      step={2}
      uuid={uuid}
      actions={[{ label: t('common.returnToMerchant'), onClick: onRedirect, variant: 'green', dataSentryElement: 'onepage-success-return' }]}
    >
      <GreenCard style={{ textAlign: 'center', padding: '28px 16px' }}>
        <CheckCircle><CheckIcon width={36} height={26} stroke="#fff" /></CheckCircle>
        <SuccessTitle>{t('success.title')}</SuccessTitle>
        <SuccessDesc>{t('success.description')}</SuccessDesc>
      </GreenCard>
    </OnePageScreen>
  );
};

export default OnePageSuccessPage;
